import React, { useContext } from "react";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";
import neptuneBadging from "../../../../assets/images/badging/SICUNET Neptune 2.0 _1.1.webp";
import layoutTemplate from "../../../../assets/images/badging/Laying out 2.1.webp";
import addingDesign from "../../../../assets/images/badging/SICUNET Adding your design 3.1.webp";
import selectUsersPrint from "../../../../assets/images/badging/sICUNET pRINT CARD 4.1.webp";
import CatalogueBackground from "../../../../assets/images/download-cutsheet2.png";
import useSWR from "swr";
import DownloadSection from "../../../../lib/downloadSection";
import { fetcher } from "../../../../lib/apiConstants";
import { LoginContext } from "../../../../lib/loginContext";

const PAGE_X = "px-6 lg:px-[120px]";

const sections = [
  {
    image: neptuneBadging,
    label: "Neptune 2.0 Badging",
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "620px",
    sectionHeight: "620px",
    htmlDescription: true,
    description: `<p class="mb-0">Sicunet badging provides the ability to create your badge templets, assign them to users and print. Native to the application, no additional software is required.</p>
      <p class="mb-0">• Feature with in the system</p>
      <p class="mb-0">• One time add on license</p>
      <p>• Mobile manager app captures image and automatically formats for system</p>`,
  },
  {
    image: layoutTemplate,
    label: "Laying out your templet is easy!",
    description:
      "This screen displays the Badge Generator interface, where users can design ID badges using customizable layout options. The left panel allows selecting badge size, orientation, print options, and guide settings. A grid layout is shown on the canvas to help users align elements accurately. To begin creating a badge, users can add text, images, or other components from the Design tab.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#ffffff",
    textAlign: "right",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "620px",
    sectionHeight: "620px",
  },
  {
    image: addingDesign,
    label: "Adding your design is simple",
    description:
      "This screen shows the Design tab of the Badge Generator, where users can add and customize elements for their ID badge. From the left panel, users can insert personal details such as first name, last name, email, and person number, as well as static text, profile images, uploaded images, barcodes, and shapes. Background color and dynamic fields like mobile phone can also be included. Users can then arrange these elements on the badge canvas to create a personalized and professional badge layout.",
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "620px",
    sectionHeight: "620px",
  },
  {
    image: selectUsersPrint,
    label: "Select your users and print",
    description:
      "This screen displays the Person tab of the Badge Generator, where users can select individuals to generate personalized badges. The left panel provides search and filter options, allowing users to locate a person by number, first name, or last name. A list of available persons is shown, and selecting one automatically applies their information to the badge preview on the right. The preview updates in real time, showing the person's name, photo, and any other assigned elements in the chosen badge layout.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#ffffff",
    textAlign: "right",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "620px",
    sectionHeight: "620px",
  },
];

export const BadgingContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR(
    "products/",
    fetcher,
  );
  const { isLoggedIn } = useContext(LoginContext);

  return (
    <div className="bg-white w-full">
      <section
        className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
      >
        <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1004px]">
          Neptune 2.0 Badge Design & Printing
        </h1>
        <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[872px]">
          Create, customize, and print professional ID badges directly within the
          platform with intuitive design tools and seamless user integration.
        </p>
      </section>

      <div className="w-full bg-white mt-6">
        {sections.map((section) => (
          <SectionBlock key={section.label} {...section} />
        ))}
      </div>

      {isLoggedIn && (
        <div className={`mx-auto pt-[60px]`}>
          <DownloadSection
            title="Cut Sheet"
            description="Learn about Badging features"
            backgroundImage={CatalogueBackground}
            buttonText="Download Now"
            linkField="others_link"
            products={products || []}
            isLoading={productsLoading}
            filterBySlug="bp-2d"
            showOnlyFirst={true}
          />
        </div>
      )}
    </div>
  );
};

export default BadgingContent;
